import { CONFIG } from "~/config";
import { store } from "~/state/store";
import { ribbonLog } from "./log";

export interface IContentNumbers {
	articles: number;
	photos: number;
	reviews: number;
	poi: number;
}

export type TLoadContentReason = "insufficient_content" | "low_resolution" | "responsive" | "iframe" | "ribbon_hidden" | "none";

interface IContentData {
	source: string;
	id: number;
	typeId: number;
	name: string;
	url: string;
}

interface IPoiData {
	source?: string;
	typeId?: number;
	id?: number;
}

type TContentType = "article" | "photo" | "review" | "poi";

interface IRibbonEvent {
	section: "ribbon";
	module: "display" | "content";
	pageType: "viewport" | "poi";
	lang?: string;
}

interface IRibbonEventLoad extends IRibbonEvent, IPoiData {
	action: "load_content";
	success: "successful" | "unsuccessful";
	reason?: TLoadContentReason;
	contentFound?: IContentNumbers;
	contentShown?: IContentNumbers;
}

export interface IRibbonEventItemShow extends IRibbonEvent, IPoiData {
	action: "display_item";
	contentType: TContentType;
	content: IContentData;
}

interface IRibbonEventScroll extends IRibbonEvent, IPoiData {
	action: "left" | "right";
}

interface IRibbonEventClick extends IRibbonEvent, IPoiData {
	action: "click";
	contentType: TContentType;
	content: IContentData;
}

interface IRibbonEventShowHide extends IRibbonEvent {
	action: "down" | "up" | "dont_show" | "restore";
	location: "ribbon" | "settings";
	defaultState: "on" | "off";
}

function log(obj: any) {
	const { action, ...rest } = obj;
	const finalObj = {
		lang: CONFIG.defaultLang,
		...rest,
	};

	ribbonLog(["ribbon analytics", action, JSON.parse(JSON.stringify(finalObj))]);
	Mapy.getComponent("logger").log(action, finalObj);
}

export function ribbonAnalyticsLoad(data: IRibbonEventLoad) {
	log(data);
}

export function ribbonAnalyticsItemShow(data: IRibbonEventItemShow) {
	log(data);
}

export function ribbonAnalyticsScroll(isRight = false) {
	const curState = store.getState();
	const isDetail = curState.detail.data !== null;
	const data: IRibbonEventScroll = {
		action: isRight ? "right" : "left",
		module: "content",
		pageType: isDetail ? "poi" : "viewport",
		section: "ribbon",
		...isDetail
			? {
				source: curState.detail.data.source,
				id: curState.detail.data.id as number,
				typeId: curState.detail.data.typeId,
			}
			: {},
	};

	log(data);
}

export function ribbonAnalyticsClick(contentType: TContentType, contentData?: Partial<IContentData>) {
	const curState = store.getState();
	const isDetail = curState.detail.data !== null;
	const data: IRibbonEventClick = {
		action: "click",
		section: "ribbon",
		module: "content",
		contentType,
		content: {
			source: "",
			id: 0,
			name: "",
			typeId: 0,
			url: "",
			...contentData,
		},
		pageType: isDetail ? "poi" : "viewport",
		...isDetail
			? {
				source: curState.detail.data.source,
				id: curState.detail.data.id as number,
				typeId: curState.detail.data.typeId,
			}
			: {},
	};

	log(data);
}

export function ribbonAnalyticsShowHide(eventData: Partial<IRibbonEventShowHide>) {
	const curState = store.getState();
	const isDetail = curState.detail.data !== null;
	const data: IRibbonEventShowHide = {
		action: "down",
		defaultState: curState.ribbon.enabled ? "on" : "off",
		location: "ribbon",
		module: "display",
		pageType: isDetail ? "poi" : "viewport",
		section: "ribbon",
		...eventData,
	};

	log(data);
}
